
const InhibitorsContent = () => {
    return (
        <>
            <h4>
                CDK inhibitors
            </h4>
            <p>
                A new class of drugs called CDK inhibitors are introduced, with palbociclib (Ibrance) becoming the first drug. These drugs block key proteins that control cell division.
            </p>
        </>
    );
}

export default InhibitorsContent;